import { createConfig, createFlowContext } from '@betterment/shared-components/src/components/flow/Flow';
import { Outlet, useParams } from 'react-router-dom';
import * as yup from 'yup';

const USER_SEARCH_SCHEMA = yup.object({
  email: yup.string().required(),
  ssn: yup.string().required(),
});

export const JOINT_ACCOUNT_FLOW_CONFIG = createConfig({
  user_search: {
    schema: USER_SEARCH_SCHEMA,
    dependencies: yup.object({}),
  },
  user_details: {
    schema: yup.object({
      firstName: yup.string().required(),
      lastName: yup.string().required(),
      phoneNumber: yup.string().required(),
    }),
    dependencies: yup.object({
      user_search: USER_SEARCH_SCHEMA,
    }),
  },
});

export const { FlowProvider, useStep: useJointAccountStep } = createFlowContext(JOINT_ACCOUNT_FLOW_CONFIG);

/**
 * DOCUMENTATION
 *
 * this bit of boilerplate will always be needed.
 * it's a great place to inject custom logic and global state as needed
 */
export const JointAccountFlow = () => {
  const { flowId } = useParams<{ flowId: string }>();

  return (
    <FlowProvider flowId={flowId}>
      <Outlet />
    </FlowProvider>
  );
};
